import httpRequest from '../../common/lib/http-request';

// *************************
// ALLOWANCE SERVICES
// *************************

function getAllowanceList(associateId) {
    return httpRequest({
        url: '/Allowance/associate/' + associateId,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function getCurrentPresenceTicketTypePrices() {
    return httpRequest({
        url: '/Allowance/presence-ticket/prices',
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function getAllowancePresenceTicketMeetings(request) {
    return httpRequest({
        url: '/Allowance/associate/presence_tickets/meetings',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function createAllowance(allowance) {
    return httpRequest({
        url: '/Allowance',
        method: 'POST',
        data: allowance
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function updateAllowance(allowance) {
    return httpRequest({
        url: '/Allowance',
        method: 'PUT',
        data: allowance
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function getAllowanceDecisionFlow(request) {
    return httpRequest({
        url: '/Allowance/history',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function submitAllowanceDailies(request) {
    return httpRequest({
        url: '/Allowance/daily/submit',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function calculateAllowanceDailyTotal(request) {
    return httpRequest({
        url: '/Allowance/daily/calculate',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function submitAllowanceInvoices(request) {
    return httpRequest({
        url: '/Allowance/invoice/submit',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function uploadAllowanceInvoice(request) {
    return httpRequest({
        url: '/Allowance/invoice/upload',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function downloadAllowanceInvoice(request) {
    return httpRequest({
        url: '/Allowance/invoice/download',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_API_URL);
}

function removeAllowanceInvoice(request) {
    return httpRequest({
        url: '/Allowance/invoice/remove',
        method: 'DELETE',
        data: request
    }, false, process.env.REACT_APP_CORE_API_URL);
}


const AllowanceService = { 
    createAllowance, updateAllowance, getAllowanceList, getCurrentPresenceTicketTypePrices, getAllowanceDecisionFlow, submitAllowanceDailies, calculateAllowanceDailyTotal, submitAllowanceInvoices, removeAllowanceInvoice, uploadAllowanceInvoice, downloadAllowanceInvoice, getAllowancePresenceTicketMeetings
}

export default AllowanceService;